import Axios from 'axios';
import { RESIDENTIAL, APIBASE_URL } from '../config/cacheKey';
import {
    IGetInfoResponse,
    IRegisterRequest,
    IUpdateRequest,
} from '../models/residential.model';
import { IRefrenceKeyRequest } from '../models/registration.model';
import {
    IRegisterDocumentRequest,
    IDocumentResponse,
    IDocumentRequest,
} from '../models/identity.model';

import { ApiResultModel } from '../models/common.model';

export const getInfo = (
    data: IRefrenceKeyRequest
): Promise<IGetInfoResponse> => {
    return Axios.post<ApiResultModel<IGetInfoResponse>>(
        APIBASE_URL + RESIDENTIAL + '/GetInfo',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const register = async (request: IRegisterRequest): Promise<boolean> => {
    const formData = new FormData();
    formData.append('residentialStatus', request.residentialStatus);
    formData.append('referenceKey', request.referenceKey);
    request.files?.forEach((item: any) => {
        formData.append('files', item, item.name);
    });

    return await Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + RESIDENTIAL + '/Register',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data; charset=utf-8',
                Accept: 'multipart/form-data',
            },
        }
    ).then((result) => {
        return result.data.data;
    });
};

export const update = (data: IUpdateRequest): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + RESIDENTIAL + '/Update',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const registerDocument = (
    request: IRegisterDocumentRequest
): Promise<IDocumentResponse> => {
    const formData = new FormData();
    formData.append('documentType', request.documentType.toString());
    formData.append('base64Date', request.base64Date.toString());
    formData.append('referenceKey', request.referenceKey.toString());
    formData.append('data', request.data, request.data.name);
    return Axios.post<ApiResultModel<IDocumentResponse>>(
        APIBASE_URL + RESIDENTIAL + '/RegisterDocument',
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data; charset=utf-8',
            },
        }
    ).then((result) => {
        return result.data.data;
    });
};

export const removeDocument = (data: IDocumentRequest): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + RESIDENTIAL + '/RemoveDocument',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const getDocument = (
    data: IDocumentRequest
): Promise<IDocumentResponse> => {
    return Axios.post<ApiResultModel<IDocumentResponse>>(
        APIBASE_URL + RESIDENTIAL + '/GetDocument',
        data
    ).then((result) => {
        return result.data.data;
    });
};
